import './Ls1Home.scss'
const Ls1Home = () => {
    return (
        <div className="container-fluid bg--main ps-0 ps-sm-0 ps-md-0 ps-lg-3">
            <div className="row d-flex p-0">
                <div className="col-sm-12 col-md-8 col-lg-6 col-xl-5">
                    <div>
                        <p className='text--manual-para'>Manual para</p>
                        <p className='text--padres'>padres</p>
                        <p className='text--de-ninos'>de ni&ntilde;os</p>
                        <p className='text-prematuros'>prematuros</p>
                    </div>
                    <div className='row d-flex'>
                        <div className='col-4'>
                            <img src='./img/conectando-juntos.png' className='img--conectando--juntos' />
                        </div>
                        <div className='col d-block d-sm-block d-md-none style--gif background--baby'>
                            <img src="./img/Ls1Baby.gif" className='img--gid' />
                            {/* ./img/Ls1Background.png */}
                        </div>
                    </div>
                </div>

                <div className="col-sm-12 col-md-4 col-lg-6 col-xl-5 d-none d-sm-block d-sm-none d-md-block">
                    <img src="./img/Ls1Baby.gif" className='style--image-baby-1' />
                </div>
            </div>

            <div className="container-fluid">
                <p className='legal--Ls1Home'>AstraZeneca Colombia S.A.S. Edificio NAOS Av. Cra. 9 No 101-67 Oficina 601 Tel. 330 9000 <br />
                    Axa Asistencia IPS S.A.S. - Tel: 646 2828 CLL 102 # 17A – 61. <br />
                    La informaci&oacute;n que contiene este material es &uacute;nicamente de car&aacute;cter informativo y no pretende reemplazar la consulta a un m&eacute;dico o profesional de la salud
                    para <br /> el diagn&oacute;stico o tratamiento de ning&uacute;n s&iacute;ntoma o enfermedad. Este material no puede ser reproducible. Material educativo dirigido a pacientes. Usted
                    est&aacute; <br /> recibiendo esta informaci&oacute;n porque ha sido prescrito por su m&eacute;dico tratante con un producto de AstraZeneca. <br />
                    <strong>MATPROM: CO-9154 Prep: 11-2022</strong></p>
            </div>
        </div>
    )
}

export default Ls1Home;